import ufeApi from 'services/api/ufeApi';
import { isUfeEnvProduction } from 'utils/Env';
import dateUtils from 'utils/Date';

const getURLEnv = function () {
    let url = '';

    if (isUfeEnvProduction) {
        url = 'https://api-developer.sephora.com/v1/promotions/validation';
    } else {
        url = 'https://extqa-api-developer.sephora.com/v1/promotions/validation';
    }

    return url;
};

function validatePromo(token, { customerID = '', promoId }) {
    const body = {
        channel: 'digital',
        device: 'web',
        cutoffDate: dateUtils.formatBeforeDateToYYYYMMDD(14),
        customerID
    };
    const url = `${getURLEnv()}/${promoId}`;

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default validatePromo;
